module.exports = __webpack_public_path__ + "static/media/emerg-banner.e6c47fba.jpg";